import React from "react";
import { COMPAT } from "../../data/site";
import "./Compat.css";

const TONE = {
  hardware: "dot",
  cloud: "dot dot--cyan",
  protocol: "dot dot--amber",
  camera: "dot dot--muted",
  model: "dot",
};

export default function Compat() {
  const items = [...COMPAT, ...COMPAT];
  return (
    <section className="compat" aria-label="Compatible hardware, clouds and protocols">
      <div className="container compat__inner">
        <div className="compat__label mono">
          Works with
          <br />
          your stack
        </div>
        <div className="marquee">
          <ul className="marquee__track">
            {items.map((it, i) => (
              <li key={`${it.label}-${i}`} className="chip" aria-hidden={i >= COMPAT.length}>
                <span className={TONE[it.kind]} />
                {it.label}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <p className="compat__note mono">
        Trademarks belong to their respective owners. Compatibility, not endorsement.
      </p>
    </section>
  );
}
